import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigurableColumn = _resolveComponent("ConfigurableColumn")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createBlock(_component_draggable, {
    list: _ctx.innerValue,
    "item-key": "name",
    onChange: _ctx.emitValue
  }, {
    item: _withCtx(({ element, index }) => [
      _createVNode(_component_ConfigurableColumn, {
        modelValue: _ctx.innerValue[index].show,
        "onUpdate:modelValue": [($event: any) => ((_ctx.innerValue[index].show) = $event), _ctx.emitValue],
        item: element,
        active: !_ctx.alwaysVisible.includes(element.name)
      }, null, 8, ["modelValue", "onUpdate:modelValue", "item", "active"])
    ]),
    _: 1
  }, 8, ["list", "onChange"]))
}